import React from 'react';
import { colors } from '../../styles/colors';
import styled from 'styled-components';

type Props = {
  title: string;
  hasBackButton?: boolean;
  className?: string;
};

export class ContentPage extends React.PureComponent<Props> {
  render() {
    const { className } = this.props;
    return <ContentPageContainer className={`ContentPage ${className}`}>
      <PageContent className="page-content">
        {
          this.props.children
        }
      </PageContent>
    </ContentPageContainer>;
  }
}

const ContentPageContainer = styled.div`
  background: ${colors.backgroundLight};

  /*
    Temporary styles to override HeroBody until we transition all pages to use
    ContentPage, or use ContentPage inside Layout.tsx.
  */
  // margin: -3rem -1.5rem -3rem -2.25rem;
`;

const PageContent = styled.div`
  padding: 1.5rem;
  min-height: calc(100vh - 5rem);
`;
